import React from 'react';
import { Link } from 'react-router-dom';
import { formatImpactScore, playerProfilePath } from '../../utils/injuryReportHeuristics';
import InjuryReportInsightChips from './InjuryReportInsightChips';
import InjuryReportPlayerIdentity from './InjuryReportPlayerIdentity';
import InjuryReportStatusPill from './InjuryReportStatusPill';
import { getTeamDisplayName, injuryReportPanelClassName } from './injuryReportStyles';

export default function InjuryReportMobileCard({ player }) {
	return (
		<Link
			to={playerProfilePath(player)}
			className={`block ${injuryReportPanelClassName} p-4 text-gray-900 dark:text-dark-text no-underline transition hover:shadow-md hover:border-blue-300 dark:hover:border-blue-500`}
		>
			<div className="flex items-start justify-between gap-3">
				<div className="flex-1">
					<InjuryReportPlayerIdentity player={player} linkToProfile={false} />
				</div>
				<div className="flex-shrink-0 text-right">
					<p className="text-xs font-bold uppercase tracking-wider text-gray-500">Impact</p>
					<p className="text-xl font-bold text-blue-600 dark:text-blue-400">
						{formatImpactScore(player.impact_score)}
					</p>
				</div>
			</div>
			{player.team && (
				<p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
					{getTeamDisplayName(player.team)}
				</p>
			)}
			<div className="mt-3 border-t border-gray-100 dark:border-dark-border pt-3">
				<InjuryReportStatusPill
					status={player.status}
					injuryDescription={player.injury_description}
				/>
			</div>
			<div className="mt-3">
				<InjuryReportInsightChips player={player} />
			</div>
		</Link>
	);
}
